/*!

=========================================================
* BLK Design System React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/blk-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/blk-design-system-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// reactstrap components
import {
  // Button,
  Card,
  CardHeader,
  // CardBody,
  // CardFooter,
  Container,
  Row,
  Col,
  // Badge,
} from "reactstrap";

export default function Products() {
  return (
    <div id="products" className="section section-signup">
      <Container>
        <div className="title">
          <h3 className="mb-3">Products</h3>
        </div>
        <div className="squares square-1" />
        <div className="squares square-2" />
        <div className="squares square-3" />
        <div className="squares square-4" />

        <Row className="mt-5 mt-sm-5">
          <Col md="6">
            <Card className="card-coin card-plain">
              <CardHeader>
                <img
                  alt="..."
                  className="img-center img-fluid"
                  src={require("assets/img/n_iot_logo.png")}
                />
                {/* <Badge
                  style={{
                    position: "absolute",
                    right: 10,
                    top: 10,
                  }}
                  color="success"
                >
                  Development
                </Badge> */}
              </CardHeader>
              {/* <CardBody>
                <Row>
                  <Col className="text-center" md="12">
                    <h4 className="text-uppercase">Akura</h4>
                  </Col>
                </Row>
              </CardBody> */}
            </Card>
          </Col>
          <Col md="6">
            <Card className="card-coin card-plain">
              <CardHeader>
                <img
                  alt="..."
                  className="img-center img-fluid"
                  src={require("assets/img/my_vitals_logo.png")}
                />
                {/* <Badge
                  style={{
                    position: "absolute",
                    right: 10,
                    top: 10,
                  }}
                  color="warning"
                >
                  Planning
                </Badge> */}
              </CardHeader>
              {/* <CardBody>
                <Row>
                  <Col className="text-center" md="12">
                    <h4 className="text-uppercase">Bantu</h4>
                  </Col>
                </Row>
              </CardBody> */}
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
